"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPin = void 0;
var mapPin = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "10",
      "r": "3"
    },
    "children": []
  }],
  "attribs": {
    "fill": "none",
    "stroke": "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }
};
exports.mapPin = mapPin;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/feather/mapPin.js
// module id = 1101
// module chunks = 0